import { NumberInput, NumberInputProps } from '@mantine/core'

export default function HeightInput(props: NumberInputProps) {
  return (
    <NumberInput
      label="Wysokość"
      description="Wysokość w przypadku firanek, szerokość w przypadku zasłon."
      placeholder="250 cm"
      allowNegative={false}
      allowDecimal={false}
      max={500}
      clampBehavior="strict"
      hideControls
      suffix=" cm"
      withAsterisk
      {...props}
    />
  )
}
